export default function processResponse (response) {
  return response.json();
};
